export default "__VITE_ASSET__882210e4__"